import { IMAGES } from "../../../../../assets/images"


const NoData = () => {
    return (
        <div className="flex justify-cneter item-center">
            <div className='rounded-2xl cursor-pointer'>
                <img src={IMAGES.noDataFound} alt="" className='rounded' />
                {
                    <div className='px-2 py-2 w-100 text-black' >
                        <p className='mb-0 text-center'>
                            No Data Found
                        </p>
                    </div>
                }
            </div>
        </div>
    )
}

export default NoData